<template>
  <div>

    <van-nav-bar
        title="用户协议"
        left-text="返回"
        right-text="首页"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
        ></van-nav-bar>

    <div class="wordText">
        <br/>
		<div class="word_content">请您在使用本服务之前，郑重承诺已经仔细阅知、理解下述各项规定并同意遵守：</div>
		
        <div class="word_content">我司将依照根据国家关于个人信息保护的法律法规履行安全保密义务，未经您的书面同意，不会将您的个人信息用于本服务以外的任何用途。</div>
		
		<div class="word_content">任何由于计算机问题、黑客攻击、计算机病毒侵入或发作、电信部门技术管制、政府行为或其他第三人的原因而造成的暂时性关闭等影响而造成的服务中断、个人资料泄露、丢失、被盗用或被窜改等，我司均得免责。</div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
    name: 'userAg',
    // import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      return {};
    },
    methods: {

        onClickLeft(){
            history.go(-1);
        },
        onClickRight()
        {
             this.$router.push({ path: '/' })
        }, 
    },
};
</script>

<style lang="less" scoped>
//@import url(); 引入公共css类
    .word_content {
        text-indent: 2em;
        line-height: 26px;
        font-size: 15px;
    }
    .word-title{
        text-align: center;
        text-indent: 0;
    } 

    .word_content{
        text-align: left;
    }
    .word-strong {
        font-weight: 600;
    }
    .word-right {
        text-align: right;
    }
    .interval{
        margin-top: 100px;
    }
    table{
        td {
            border-right: 1px solid #000;
            border-bottom: 1px solid #000;
            border-top: 0;
            border-left: 0;
            font-size: 12px;
        }
    }
</style>
